import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

/* *****************
  CONTAINER
* **************** */

// TODO: Adjust logic so the nmx-container modifier only gets appended when needed
export const Container = ({
  id, className, styles, children, home, inner,
}) => {
  const classNames = {
    'nmx-container': true,
    'nmx-container-home': !!home,
    'nmx-container-inner': !!inner,
    [className]: !!className,
  };
  return (
    <div id={id} className={classnames(classNames)} style={styles || {}}>
      {children}
    </div>
  );
};

Container.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  children: PropTypes.node.isRequired,
  /** Only specify if this is on the home page */
  home: PropTypes.bool,
  /** Is this container a child of another container? */
  inner: PropTypes.bool,
  id: PropTypes.string,
};

Container.defaultProps = {
  className: null,
  styles: null,
  children: '',
  home: false,
  inner: false,
};

/* *****************
  ROW
* **************** */

export const Row = ({
  id, className, styles, children, reverse, align,
}) => {
  const classNames = {
    'nmx-row': true,
    'nmx-row--reverse': reverse,
    [`nmx-row--align-${align}`]: !!align,
    [className]: !!className,
  };
  return (
    <div id={id} className={classnames(classNames)} style={styles || {}}>
      {children}
    </div>
  );
};

Row.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  children: PropTypes.node.isRequired,
  /** Reverse the grid cols in this row? */
  reverse: PropTypes.bool,
  /** How to align the grid cols in the row */
  align: PropTypes.oneOf(['center', 'left', 'right']),
  id: PropTypes.string,
};

Row.defaultProps = {
  className: null,
  styles: null,
  children: '',
  reverse: false,
  align: null,
};

/* *****************
  COL
* **************** */

export const Col = ({
  className,
  styles,
  children,
  nested,
  nestedChild,
  paddingRight,
  paddingLeft,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xsmallOffset,
  smallOffset,
  mediumOffset,
  largeOffset,
  xlargeOffset,
  id,
  ...otherProps
}) => {
  const classNames = {
    'nmx-col': true,
    'nmx-col-nested': !!nested,
    'nmx-col-nested-child': !!nestedChild,
    'nmx-col-left-text-padding-right': !!paddingRight,
    'nmx-col-left-text-padding-left': !!paddingLeft,
    [className]: !!className,
    [`nmx-col-xsmall-${xsmall}`]: (xsmall === 0 || !!xsmall),
    [`nmx-col-small-${small}`]: (small === 0 || !!small),
    [`nmx-col-medium-${medium}`]: (medium === 0 || !!medium),
    [`nmx-col-large-${large}`]: (large === 0 || !!large),
    [`nmx-col-xlarge-${xlarge}`]: (xlarge === 0 || !!xlarge),
    [`nmx-col-xsmall--offset-${xsmallOffset}`]: !!xsmallOffset,
    [`nmx-col-small--offset-${smallOffset}`]: !!smallOffset,
    [`nmx-col-medium--offset-${mediumOffset}`]: !!mediumOffset,
    [`nmx-col-large--offset-${largeOffset}`]: !!largeOffset,
    [`nmx-col-xlarge--offset-${xlargeOffset}`]: !!xlargeOffset,
  };
  return (
    <div id={id} className={classnames(classNames)} style={styles || {}} {...otherProps}>
      {children}{' '}
    </div>
  );
};

Col.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  children: PropTypes.node.isRequired,
  nested: PropTypes.bool,
  nestedChild: PropTypes.bool,
  paddingRight: PropTypes.bool,
  paddingLeft: PropTypes.bool,
  xsmall: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  small: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  medium: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  large: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xlarge: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xsmallOffset: PropTypes.number,
  smallOffset: PropTypes.number,
  mediumOffset: PropTypes.number,
  largeOffset: PropTypes.number,
  xlargeOffset: PropTypes.number,
  id: PropTypes.string,
};

Col.defaultProps = {
  className: null,
  styles: null,
  children: '',
  nested: false,
  nestedChild: false,
  paddingRight: false,
  paddingLeft: false,
  xsmall: null,
  small: null,
  medium: null,
  large: null,
  xlarge: null,
  xsmallOffset: null,
  smallOffset: null,
  mediumOffset: null,
  largeOffset: null,
  xlargeOffset: null,
};
